import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    margin: '10px 40px 24px'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
  },
  subTitle: {
    fontSize: '16px',
    color: '#545455',
    marginTop: '10px'
  },
  cardWrapper: {
    margin: '15px 40px',
    padding: '20px',
    backgroundColor: '#F9F9F9',
    minHeight: '150px',
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    border: '1px solid #F9F9F9',
    '&:hover': {
      border: '1px solid #F37320',
    }
  },
  customCardWrapper: {
    '&:hover': {
      border: '1px solid #F9F9F9',
    }
  },
  cardImg: {
    width: '80px',
  },
  cardTitle: {
    color: '#292929',
    fontSize: '20px',
    fontWeight: 600,
    margin: '0 20px',
    cursor: 'pointer',
    display: 'flex',
    '&:hover': {
      color: '#F37320',
      "& $cardTextArrow": {
        visibility: 'visible',
        transform: 'translate(8px, 0px)',
        transition: 'transform 0.5s ease'
      }
    }
  },
  subCard: {
    minHeight: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'column',
    margin: '10px 15px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #70707033',
    borderRadius: '5px',
    padding: '25px',
    width: '120px',
    wordBreak: 'break-word',
    textAlign: 'center',
    position: 'relative',
    '&:hover': {
      cursor: 'pointer',
      border: '1px solid #F37320',
      backgroundColor: '#FFFAF7',
      transform: 'scaleX(1.05) scaleY(1.05)',
      transition: 'transform 0.5s'
    }
  },
  subCardImg: {
    width: '28px',
    height: '28px'
  },
  subCardTitle: {
    fontSize: '14px'
  },
  betaTag: {
    position: 'absolute',
    top: '-20px',
    right: '-20px',
    width: '70px',
    zIndex: 10
  },
  apiDataCard: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    backgroundColor: '#FFFFFF',
    border: '1px solid #70707033',
    margin: '20px',
    padding: '15px',
    minWidth: '300px',
    borderRadius: '5px',
    '@media (max-width: 600px)': {
      justifyContent: 'center',
      width: '100%',
      minWidth: '0px',
      maxWidth: '300px',
      textAlign: 'center'
    },
    '&:hover': {
      cursor: 'pointer',
      border: '1px solid #F37320',
      backgroundColor: '#FFFAF7',
      transform: 'scaleX(1.05) scaleY(1.05)',
      transition: 'transform 0.5s'
    }
  },
  apiCardImg: {
    width: '80px',
    height: '80px',
    marginRight: '20px',
    '@media (max-width: 600px)': {
      marginBottom: '10px'
    },
  },
  apiCardText: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#404040',
    display: 'flex',
    '&:hover': {
      color: '#F37320',
      "& $cardTextArrow": {
        visibility: 'visible',
        transform: 'translate(8px, 0px)',
        transition: 'transform 0.5s ease'
      }
    }
  },
  cardTextArrow: {
    color: '#F37320',
    fontWeight: 'bold',
    visibility: 'hidden'
  },
  customSubCard: {
    '&:hover': {
      border: '1px solid #F9F9F9',
      backgroundColor: '#FFFFFF',
    }
  },
}))

export { useStyles }